/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Letztegeskrankenkasseid4Inputs */



/**

* @param {_Field_Letztegeskrankenkasseid4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_letztegeskrankenkasseid4 = /** @type {((inputs?: _Field_Letztegeskrankenkasseid4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Letztegeskrankenkasseid4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Transitkrankenkasse")
});
export { _field_letztegeskrankenkasseid4 as "_field_letzteGesKrankenkasseID" }